import type { VentureId } from '@squadlab/contracts';

/**
 * Leave ledger primitives (P5): taken working days per employee per venture,
 * kept in an in-memory store in v1 (durable persistence is backlog N2).
 */

/** Taken working days this leave year, keyed by {@link leaveKey}. */
export type LeaveTaken = Readonly<Record<string, number>>;

export function leaveKey(ventureId: VentureId, employeeId: string): string {
  return `${ventureId}/${employeeId}`;
}

const MS_PER_YEAR = 365.2425 * 86_400_000;

/** Fractional service years from a contract start date at a given instant. */
export function serviceYearsAt(startDateIso: string, nowMs: number): number {
  return Math.max(0, (nowMs - new Date(`${startDateIso}T00:00:00Z`).getTime()) / MS_PER_YEAR);
}
